import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import "./login.css";
import loginImage from "../../images/login.jpg";
import { useNavigate } from "react-router-dom";
import { LoginService } from "../../services/loginService";

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isCheckingToken, setIsCheckingToken] = useState<boolean>(true); // To avoid flicker
  const navigate = useNavigate();

  // ✅ On component load, check for existing token and refresh if possible
  useEffect(() => {
    const checkAndRefreshToken = async () => {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");

      if (token && refreshToken) {
        try {
          const response = await LoginService.refreshToken();
          if (response?.token) {
            localStorage.setItem("token", response.token);
            localStorage.setItem("refreshToken", response.refreshToken || refreshToken);
            navigate("/dashboard");
            return;
          }
        } catch (error) {
          console.warn("Token refresh failed:", error);
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
        }
      }

      setIsCheckingToken(false); // Allow login form to render
    };

    checkAndRefreshToken();
  }, [navigate]);

  const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Please enter email and password");
      return;
    }

    try {
      // Call your login API
      const response = await LoginService.login({ email, password });

      // Store tokens in localStorage
      localStorage.setItem("token", response.token);
      localStorage.setItem("refreshToken", response.refreshToken);

      // Redirect to dashboard
      navigate("/dashboard");
    } catch (error: any) {
      alert(error.response?.data?.message || "Login failed");
    }
  };

  // While checking for token, show loader or nothing
  if (isCheckingToken) {
    return <div className="login-loading">Checking session...</div>;
  }

  return (
    <div className="login-container">
      <div className="login-left">
        <img src={loginImage} alt="File Manager" className="illustration" />
        <h2>Theekkathir Cloud Drive</h2>
        <p>Login to use cloud drive</p>
      </div>

      <div className="login-right">
        <h1>Welcome</h1>
        <p>Sign into your account.</p>

        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
            required
          />
          <a href="#" className="forgot-password">
            Forgot Password?
          </a>
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
